import { Cliente } from '../models/cliente.model';
import { Usuario } from '../models/usuario.model';
import { FormatadorHelper } from './formatador.helper';

export class MapeamentoHelper {
  static mapeaFormParaCliente(formValues: any): Cliente {
    const cliente = new Cliente();
    cliente.id = formValues.id || 0;
    cliente.apelido = formValues.apelido || '';
    cliente.razaoSocial = formValues.razaoSocial || '';
    
    cliente.cpfCnpj = formValues.cpfCnpj !== null && formValues.cpfCnpj !== undefined
      ? FormatadorHelper.normalizarDocumento(formValues.cpfCnpj)
      : '';

    cliente.codigoMunicipio = formValues.codigoMunicipio !== null && formValues.codigoMunicipio !== undefined
      ? formValues.codigoMunicipio.toString()
      : '';

    cliente.municipio = formValues.municipio || '';
    cliente.telefone = formValues.telefone || '';
    cliente.email = formValues.email || '';
    cliente.tipoLogradouro = formValues.tipoLogradouro || '';
    cliente.inscricaoMunicipal = formValues.inscricaoMunicipal || '';
    cliente.logradouro = formValues.logradouro || '';
    cliente.numero = formValues.numero || '';
    cliente.complemento = formValues.complemento || '';
    cliente.bairro = formValues.bairro || '';
    cliente.municipio = formValues.municipio || '';
    cliente.uf = formValues.uf !== null && formValues.uf !== undefined ? formValues.uf : '';
    cliente.cep = formValues.cep !== null && formValues.cep !== undefined ? formValues.cep : '';
    
    cliente.pais = formValues.pais;
    cliente.usuarioId = formValues.usuarioId || '';
    cliente.usuario = formValues.usuario || new Usuario();
    cliente.faturamentosId = formValues.faturamentosId || [];
    return cliente;
  }
}
